const cs_error_codes = {
    USER_NOT_LOGGED_IN: "USER_NOT_LOGGED_IN"
}

export default cs_error_codes
